import { render, staticRenderFns } from "./ControlCota.vue?vue&type=template&id=5df988e2&scoped=true&lang=pug&"
import script from "./ControlCota.vue?vue&type=script&lang=js&"
export * from "./ControlCota.vue?vue&type=script&lang=js&"
import style0 from "./ControlCota.vue?vue&type=style&index=0&id=5df988e2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df988e2",
  null
  
)

export default component.exports